import React from "react";

import Books from "./books";
import Introduction from "./introduction";
import AuthorBio from "./authorBio";
import Trailers from "./trailers";
import * as api from "../lib/api";
import LatestNews from "./latestNews";

const Content = () => {
  const availableBooks = api.getVisibleBooks();
  const featuredBooks = api.getFeaturedBooks(availableBooks);
  const trailers = api.getTrailers(availableBooks);

  return (
    <div className="contents">
      <Introduction title="Introduction" tag="intro" />
      <Books
        title="Featured Books"
        tag="featured"
        items={featuredBooks}
        hideFilters
        bottomContent={
          <div className="featuredMessage">
            To receive updates on new or upcoming books, follow me on{" "}
            <a
              href="https://www.amazon.com/stores/C.-W.-Hambleton/author/B00CWRMYXA"
              target="_blank"
              rel="noreferrer"
            >
              Amazon
            </a>
            ,{" "}
            <a
              href="https://www.facebook.com/cwhambleton"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
            , or{" "}
            <a
              href="https://x.com/cwhambletonbks"
              target="_blank"
              rel="noreferrer"
            >
              X
            </a>
            !
          </div>
        }
      />
      <LatestNews title="Latest News" />
      <AuthorBio title="About Me" tag="about" />
      <Trailers
        title="Book Trailers"
        tag="trailers"
        items={trailers}
        isSliderMode
      />
      <Books
        title="Fiction Books"
        tag="fiction"
        bySeries
        hideFilters
        items={availableBooks}
        genre={"fiction"}
      />
      <Books
        title="Nonfiction Books"
        tag="nonfiction"
        items={availableBooks}
        genre={"nonfiction"}
      />
      <Books
        title="Kindle Singles"
        tag="singles"
        items={availableBooks}
        genre={"single"}
      />
    </div>
  );
};

export default Content;
